import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";

import { AddPostScreen } from "../components";
import usePermission from "@/hooks/usePermission";

export const AddPost = () => {
  const { showPost } = usePermission();

  return (
    <ContentLayout title="Add Post" showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={
              <div>
                You are not allowed to view this. Please contact administrator
              </div>
            }
            allowedRoles={[ROLES.USER]}
            policyCheck={showPost}
          >
            <AddPostScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
